import { variant } from 'styled-system';

export const outlined = variant({
  variants: {
    primary: {
      backgroundColor: 'white',
      color: 'primary.100',
      border: '1px solid',
      borderColor: 'primary.100',
      '&:hover': {
        color: 'white',
        borderColor: 'primary.80',
        backgroundColor: 'primary.80',
        svg: {
          path: {
            fill: 'white',
          },
        },
      },
      '&:focus': {
        color: 'primary.120',
        borderColor: 'primary.120',
        backgroundColor: 'white',
        svg: {
          path: {
            stroke: 'primary.120',
          },
        },
      },
      '&:disabled': {
        color: 'primary.100',
        borderColor: 'primary.100',
        backgroundColor: 'white',
        opacity: 0.2,
        pointerEvents: 'none',
      },
    },
    error: {
      backgroundColor: 'white',
      color: 'error.default',
      border: '1px solid',
      borderColor: 'error.default',
      '&:hover': {
        color: 'error.light',
        borderColor: 'error.light',
        backgroundColor: 'white',
        svg: {
          path: {
            stroke: 'error.light',
          },
        },
      },
      '&:focus': {
        color: 'error.darker',
        borderColor: 'error.darker',
        backgroundColor: 'white',
        svg: {
          path: {
            stroke: 'error.darker',
          },
        },
      },
      '&:disabled': {
        color: 'error.default',
        borderColor: 'error.default',
        backgroundColor: 'white',
        opacity: 0.2,
        pointerEvents: 'none',
      },
    },
    grey: {
      backgroundColor: 'white',
      color: 'black.60',
      border: '1px solid',
      borderColor: 'black.60',
      '&:hover': {
        color: 'white',
        backgroundColor: 'black.60',
        svg: {
          path: {
            stroke: 'white',
          },
        },
      },
      '&:focus': {
        color: 'primary.120',
        backgroundColor: 'white',
        svg: {
          path: {
            stroke: 'primary.120',
          },
        },
      },
      '&:disabled': {
        color: 'primary.100',
        borderColor: 'primary.100',
        backgroundColor: 'white',
        opacity: 0.2,
        pointerEvents: 'none',
      },
    },
    black: {
      backgroundColor: 'white',
      color: 'black.100',
      border: '1px solid',
      borderColor: 'black.100',
      '&:hover': {
        color: 'white',
        borderColor: 'black.60',
        backgroundColor: 'black.60',
        svg: {
          path: {
            stroke: 'white',
          },
        },
      },
      '&:focus': {
        color: 'black.60',
        backgroundColor: 'white',
        svg: {
          path: {
            stroke: 'black.120',
          },
        },
      },
      '&:disabled': {
        color: 'black.60',
        borderColor: 'black.60',
        backgroundColor: 'white',
        opacity: 0.2,
        pointerEvents: 'none',
      },
    },
  },
});

export const contained = variant({
  variants: {
    primary: {
      backgroundColor: 'primary.100',
      color: 'white',
      border: '1px solid',
      borderColor: 'primary.100',
      '&:hover': {
        borderColor: 'primary.80',
        backgroundColor: 'primary.80',
      },
      '&:focus': {
        backgroundColor: 'primary.120',
        borderColor: 'primary.120',
      },
      '&:disabled': {
        backgroundColor: 'primary.100',
        color: 'white',
        border: '1px solid',
        borderColor: 'primary.100',
        opacity: 0.2,
        pointerEvents: 'auto',
      },
    },
    error: {
      backgroundColor: 'notification',
      color: 'white',
      border: '1px solid',
      borderColor: 'notification',
      boxShadow: 'none',
      '&:hover': {
        backgroundColor: 'error.light',
      },
      '&:focus': {
        backgroundColor: 'error.darker',
        borderColor: 'error.darker',
      },
      '&:disabled': {
        backgroundColor: 'notification',
        color: 'white',
        border: '1px solid',
        borderColor: 'notification',
        boxShadow: 'none',
        opacity: 0.2,
        pointerEvents: 'none',
      },
      '&:disabled:hover': {
        backgroundColor: 'notification',
      },
    },
    success: {
      backgroundColor: 'success.default',
      color: 'white',
      border: '1px solid',
      borderColor: 'success.default',
      boxShadow: 'none',
      '&:hover': {
        backgroundColor: 'success.light',
        borderColor: 'success.light',
      },
      '&:focus': {
        backgroundColor: 'success.darker',
        borderColor: 'success.darker',
      },
      '&:disabled': {
        backgroundColor: 'success.default',
        color: 'white',
        border: '1px solid',
        borderColor: 'success.default',
        boxShadow: 'none',
        opacity: 0.2,
        pointerEvents: 'auto',
      },
      '&:disabled:hover': {
        backgroundColor: 'success.default',
      },
    },
  },
});

export const text = variant({
  variants: {
    primary: {
      border: 'none',
      backgroundColor: 'transparent',
      color: 'primary.100',
      '&:hover, &:focus:hover': {
        color: 'primary.100',
        borderColor: 'primary.10',
        backgroundColor: 'primary.10',
      },
      '&:focus': {
        backgroundColor: 'transparent',
        color: 'primary.100',
      },
      '&:disabled': {
        color: 'primary.60',
        backgroundColor: 'white',
        opacity: 0.2,
        pointerEvents: 'none',
      },
    },
    grey: {
      border: 'none',
      backgroundColor: 'transparent',
      color: 'black.60',
      '&:hover': {
        color: 'black.60',
        borderColor: 'black.60',
        backgroundColor: 'black.10',
      },
      '&:focus': {
        color: 'black.60',
        borderColor: 'black.60',
        backgroundColor: 'transparent',
      },
      '&:active': {
        color: 'black.60',
        backgroundColor: 'black.20',
      },
      '&:disabled': {
        color: 'black.60',
        backgroundColor: 'white',
        opacity: 0.2,
        pointerEvents: 'none',
      },
    },
    black: {
      border: 'none',
      backgroundColor: 'transparent',
      color: 'black.100',
      outline: 'none',
      '&:hover': {
        color: 'black.100',
        borderColor: 'black.60',
        backgroundColor: 'black.10',
      },
      '&:focus': {
        color: 'black.100',
        backgroundColor: 'transparent',
      },
      '&:active': {
        color: 'black.60',
        backgroundColor: 'black.20',
      },
      '&:disabled': {
        color: 'black.60',
        backgroundColor: 'white',
        opacity: 0.2,
        pointerEvents: 'none',
      },
    },
    error: {
      border: 'none',
      backgroundColor: 'transparent',
      color: 'error.default',
      outline: 'none',
      '&:hover': {
        color: 'error.light',
        borderColor: 'error.light',
        backgroundColor: 'white',
      },
      '&:focus': {
        color: 'error.darker',
        borderColor: 'error.darker',
        backgroundColor: 'transparent',
      },
      '&:disabled': {
        color: 'error.default',
        backgroundColor: 'white',
        opacity: 0.2,
        pointerEvents: 'none',
      },
    },
  },
});
